import { Pipe, PipeTransform } from '@angular/core';
import { MANGLISH_LAYOUT } from '@otas/utils/directives/extras/manglish-layout';

@Pipe({
    name: 'manglish',
    standalone: false
})
export class ManglishWordPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value) {
      return value;
    }
    return MANGLISH_LAYOUT[value];
  }

}
